import React from "react"

import { styled, TextFieldProps } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { IconButton, MuiIcon, TextField } from "@cirrus/ui-kit-ts"

export const CommentsFilter = ({ isSortAsc, onSearchChange, onSortClick }: Props) => {
  const { i18n } = useTranslations()

  return <Layout>
    <TextField
      disableUnderline
      width="100%"
      variant="outlined"
      onChange={onSearchChange}
      startAdornment={<MuiIcon.Search />}
      placeholder={i18n("General:Search")}
      background={"#F2F2F2"}
    />

    <IconButton size="small"
                onClick={onSortClick}
                title={i18n("General:Sorting")}
                className="sort-button">
      <MuiIcon.Sort sx={{ transform: `rotateX(${isSortAsc ? "0": "180deg"})` }} />
    </IconButton>
  </Layout>
}

type Props = {
  isSortAsc: boolean,
  onSearchChange: TextFieldProps["onChange"],
  onSortClick: () => void
}

const Layout = styled("div")({
  display: "grid",
  rowGap: ".8rem",

  "& .sort-button": {
    justifySelf: "end",
  }
})
